export default{
    init(){
        this.articleCategoryActions();
        this.saveCategory();
        this.articlesActions();
    },
    articleCategoryActions(){
        $('#create-article-category').click(()=>{
            this.getForm({form_type:'create', entity: 'category'}, ()=>{$('#create_category_form').modal('show');});
        });
        $('.edit-article-category').click((e)=>{
            this.getForm({form_type:'edit', entity: 'category', id: $(e.currentTarget).parents('tr').data('id')}, ()=>{$('#edit_category_form').modal('show');});
        });
        $('.delete-article-category').click(function () {
            const id = $(this).parents('tr').data('id');
            $.ajax({
                method: "POST",
                url: `/admin/articles-management/category/${id}/delete`,
                success: (response) => {
                    location.reload(true);
                },
                error: (response) => {
                    console.log(response);
                }
            });
        });
    },
    saveCategory(){
        $('body').on('click', '.save-article-category', function(e) {
            $(this).attr('disabled', 'disabled');
            const data = {
                parent_id: $('.article-category-form').find('#parent').val() == "" ? null : $('.article-category-form').find('#parent').val(),
                title: $('.article-category-form').find('#title').val(),
                link: $('.article-category-form').find('#link').val(),
                id: $('.article-category-form').find('[name="id"]').val(),
            }
            $.ajax({
                method: "POST",
                url: '/admin/articles-management/category/create',
                data: data,
                success: (response) => {
                    location.reload(true);
                },
                error: (response) => {
                    console.log(response);
                    $(this).removeAttr('disabled');
                }
            });
        })
    },
    getForm(data, successCallback = ()=>{}, errCallback = ()=>{}){
        $.ajax({
            method: "GET",
            url: '/admin/articles-management/category/get-form',
            data: data,
            success:(response)=>{
                $('#form-container').html(response);
                successCallback();
            },
            error: errCallback
        });
    },
    articlesActions(){
        $('#articles-mangement').on('change', '#article-category-filter', function() {
            location.href = location.pathname+'?category='+$(this).val();
        })
    }
}
